var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundflow3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#000000;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256.004,222.135c-18.702,0-33.868,15.166-33.868,33.868c0,18.694,15.166,33.86,33.868,33.86 c18.695,0,33.86-15.166,33.86-33.86C289.864,237.302,274.698,222.135,256.004,222.135z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M237.354,196.038c2.05,8.402,9.618,14.648,18.65,14.648c9.024,0,16.592-6.246,18.65-14.648l37.344-123.4 c1.239-4.715,1.9-9.648,1.9-14.738c0-31.983-25.917-57.9-57.893-57.9c-31.976,0-57.9,25.917-57.9,57.9 c0,5.09,0.668,10.023,1.899,14.738L237.354,196.038z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M274.653,315.946c-2.057-8.401-9.626-14.632-18.65-14.632c-9.032,0-16.6,6.231-18.65,14.632l-37.352,123.422 c-1.231,4.708-1.899,9.64-1.899,14.738c0,31.969,25.924,57.894,57.9,57.894c31.976,0,57.893-25.925,57.893-57.894 c0-5.098-0.66-10.03-1.9-14.738L274.653,315.946z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.746,165.932l113.669,60.859c7.403,4.482,17.164,3.559,23.552-2.823c6.382-6.396,7.313-16.15,2.831-23.552 L165.939,86.746c-2.456-4.197-5.473-8.161-9.085-11.765c-22.606-22.614-59.26-22.614-81.874,0 c-22.614,22.606-22.614,59.267,0,81.873C78.585,160.451,82.549,163.484,86.746,165.932z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M425.254,346.061l-113.67-60.859c-7.395-4.49-17.155-3.552-23.537,2.83c-6.396,6.396-7.327,16.15-2.845,23.552 l60.866,113.67c2.455,4.204,5.466,8.161,9.076,11.756c22.614,22.615,59.268,22.615,81.874,0c22.621-22.598,22.614-59.26,0-81.866 C433.415,351.542,429.466,348.516,425.254,346.061z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196.046,274.653c8.402-2.057,14.64-9.626,14.64-18.65c0-9.032-6.239-16.6-14.64-18.658L72.638,200.002 c-4.714-1.238-9.648-1.899-14.738-1.899c-31.976,0-57.9,25.924-57.9,57.9c0,31.976,25.925,57.893,57.9,57.893 c5.09,0,10.024-0.668,14.738-1.9L196.046,274.653z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M454.106,198.103c-5.098,0-10.03,0.66-14.738,1.899l-123.414,37.344c-8.394,2.058-14.64,9.626-14.64,18.658 c0,9.024,6.246,16.592,14.64,18.65l123.414,37.344c4.708,1.232,9.64,1.9,14.738,1.9c31.976,0,57.894-25.917,57.894-57.893 C512,224.02,486.083,198.103,454.106,198.103z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.967,288.032c-6.389-6.382-16.15-7.32-23.552-2.83L86.746,346.061c-4.197,2.455-8.161,5.481-11.765,9.084 c-22.614,22.606-22.614,59.268,0,81.866c22.614,22.615,59.268,22.615,81.874,0c3.596-3.596,6.629-7.552,9.077-11.756l60.866-113.67 C231.28,304.182,230.349,294.428,223.967,288.032z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M288.047,223.953c6.382,6.396,16.142,7.32,23.537,2.838l113.67-60.851c4.212-2.456,8.161-5.474,11.764-9.085 c22.614-22.606,22.621-59.267,0-81.873c-22.606-22.614-59.267-22.614-81.874,0c-3.611,3.604-6.622,7.568-9.076,11.765 l-60.866,113.669C280.72,207.818,281.651,217.571,288.047,223.953z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundflow3);
export default __webpack_public_path__ + "static/media/roundflow3.a6495075a9491bb0f92b87f08c3b776d.svg";
export { ForwardRef as ReactComponent };